import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import InsertChartOutlinedRoundedIcon from "@mui/icons-material/InsertChartOutlinedRounded";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import { Chip, Tooltip } from "@mui/material";
import type { ReactElement } from "react";
import type { ArtifactPickKind } from "@entrilia/shared/artifactRuntime/protocol";
import { pickKindWords } from "@entrilia/shared/artifactRuntime/pickKindWords";
import type { PickedPart } from "./pickedParts";

const kindIcons: Record<ArtifactPickKind, ReactElement> = {
  chart: <InsertChartOutlinedRoundedIcon />,
  table: <TableChartOutlinedIcon />,
  tile: <DashboardOutlinedIcon />,
  section: <DashboardOutlinedIcon />,
};

interface Props {
  part: PickedPart;
  disabled?: boolean;
  onDelete?: () => void;
}

const ArtifactAgentPickedPartChip = ({ part, disabled, onDelete }: Props) => (
  <Tooltip title={part.componentLocation} placement="top" arrow>
    <Chip
      icon={kindIcons[part.kind]}
      label={part.label || pickKindWords[part.kind]}
      disabled={disabled}
      onDelete={onDelete}
      sx={{ maxWidth: "100%" }}
    />
  </Tooltip>
);

export default ArtifactAgentPickedPartChip;
